import React from 'react';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = ({ items, onNavigate }) => {
  return (
    <nav className="flex items-center gap-2 text-sm mb-4" aria-label="Breadcrumb">
      <button
        onClick={() => onNavigate('dashboard')}
        className="flex items-center gap-1 text-gray-400 hover:text-white transition-colors"
      >
        <Home size={16} />
        Dashboard
      </button>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight size={16} className="text-gray-600" />
          {item.onClick ? (
            <button
              onClick={item.onClick}
              className="text-gray-400 hover:text-white transition-colors"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-white font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
